import { postEntitiesByFpIdTokenMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import type { ContactInfoKind, TokenOperationKind } from '@onefootprint/request-types/dashboard';
import { useToast } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type SendLinkMutationProps = {
  kind: TokenOperationKind;
  sendTo: ContactInfoKind;
  onDone: () => void;
};

const useSendTokenLinkMutation = (entityId: string) => {
  const { t } = useTranslation('entity-details', {
    keyPrefix: 'actions.sendLink',
  });
  const showRequestErrorToast = useRequestErrorToast();
  const generateTokenMutation = useMutation(postEntitiesByFpIdTokenMutation());
  const { toast } = useToast();

  const { isPending } = generateTokenMutation;

  const mutate = ({ kind, sendTo, onDone }: SendLinkMutationProps) => {
    generateTokenMutation.mutate(
      { body: { kind, sendLinkTo: [sendTo] }, path: { fpId: entityId } },
      {
        onSuccess: response => {
          toast({
            title: t($ => $.header),
            description: t($ => $.description[response.deliveryMethods[0]]),
          });
          onDone();
        },
        onError: (error: unknown) => {
          showRequestErrorToast(error);
          onDone();
        },
      },
    );
  };
  return { mutate, isPending };
};

export default useSendTokenLinkMutation;
